import React from "react";
import "./Loader.css"; // Ensure this file is in the correct path

const LoaderComponent = () => {
  return (
    <div className="loader" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default LoaderComponent;
